import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators'; // Separater Import für Operatoren
import { environment } from '../environments/environment';
import { Equipment } from '../Models/equipment.model';
import { Customer } from '../Models/customer.model'; // Customer-Modell importieren
import { CustomerService } from './customer.service';

@Injectable({ providedIn: 'root' })
export class EquipmentService {
  private apiUrl = environment.apiBaseUrl + '/equipment';

  constructor(private http: HttpClient, public customerService: CustomerService) { }

  getEquipments(): Observable<Equipment[]> {
    return this.http.get<Equipment[]>(this.apiUrl);
  }

  getEquipmentsByCustomer(customerId: number): Observable<Equipment[]> {
    return this.http.get<Equipment[]>(`${this.apiUrl}/Customer/${customerId}`);
  }

  getEquipment(id: number): Observable<Equipment> {
    return this.http.get<Equipment>(`${this.apiUrl}/${id}`);
  }

  createEquipment(equipment: any): Observable<Equipment> {
    // Get the selected customer based on customerId
    return this.customerService.getCustomer(equipment.customerId).pipe(
      switchMap((customer: Customer) => { // Typisierung hinzugefügt
        // Create the payload with both customerId and customer object
        const payload = {
          ...equipment,
          customer: customer
        };

        return this.http.post<Equipment>(this.apiUrl, payload);
      })
    );
  }

  updateEquipment(id: number, equipment: Equipment): Observable<void> {
    // Falls bei der Aktualisierung auch ein Customer-Objekt benötigt wird
    if (equipment.customerId && !equipment.customer) {
      return this.customerService.getCustomer(equipment.customerId).pipe(
        switchMap((customer: Customer) => { // Typisierung hinzugefügt
          const payload = {
            ...equipment,
            customer: customer
          };
          return this.http.put<void>(`${this.apiUrl}/${id}`, payload);
        })
      );
    } else {
      // Ursprüngliche Implementierung, falls customer bereits vorhanden ist
      return this.http.put<void>(`${this.apiUrl}/${id}`, equipment);
    }
  }

  deleteEquipment(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
